const customerName = ({ fields }) => {
	const {company_name, last_name, first_name} = fields;
	let name = '';
	if ( last_name && first_name ) {
		name += `${first_name} ${last_name}`
	} else if ( first_name ) {
		name += first_name
	} else if ( last_name ) {
		name += last_name
	}
	if ( company_name && name ) {
		name = `${company_name} – ${name}`
	} else if ( company_name ) {
		name = company_name
	}
	if ( ! name ) {
		name = '–';
	}
	return name;
}

export default customerName



// WEBPACK FOOTER //
// ./src/CollectorAccount/customerName.js